<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  created () {
  },
};
</script>

<style lang="scss">
// 引入移动端响应式样式
@import './assets/styles/mobile.scss';
</style>

<style>
@import url(https://fonts.googleapis.com/css?family=Raleway:300,400,600);

/* iOS Safari 特定修复 */
html {
  /* 修复 iOS Safari 100vh 问题 */
  height: -webkit-fill-available;
  /* 启用平滑滚动 */
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  font-size: 14px;
  color: #333333;
  padding: 0;
  /* iOS Safari 高度适配 */
  min-height: 100vh;
  min-height: -webkit-fill-available;
  /* 优化触摸滚动 */
  -webkit-overflow-scrolling: touch;
  /* 禁用文本大小调整 */
  -webkit-text-size-adjust: 100%;
  /* 优化字体渲染 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
  /* iOS Safari 最小高度 */
  min-height: 100vh;
  min-height: -webkit-fill-available;
}

/* 全局链接触摸优化 */
a, button {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

/* 输入框 iOS 优化 - 防止自动缩放 */
input, textarea, select {
  font-size: 16px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* iOS Safari 滚动条隐藏 */
::-webkit-scrollbar {
  height: 3px;
  width: 3px;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 20px;
}

::-webkit-scrollbar-track-piece {
  background: #ccc;
  border-radius: 3px;
}

/* 移动端滚动条隐藏 */
@media screen and (max-width: 768px) {
  ::-webkit-scrollbar {
    display: none;
  }
  
  * {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
  }
}

/* 图片优化 */
img {
  max-width: 100%;
  height: auto;
  /* 防止图片拖动 */
  -webkit-user-drag: none;
  user-select: none;
}

/* iOS 安全区域适配 */
@supports (padding: max(0px)) {
  .safe-area-padding {
    padding-left: max(16px, env(safe-area-inset-left));
    padding-right: max(16px, env(safe-area-inset-right));
  }
}

@font-face {
  font-family: alibaba;
  src: url("./assets/font/AlibabaPuHuiTi.ttf");
}
@font-face {
  font-family: Bodoni;
  src: url("./assets/font/Bodoni.ttf");
}

@font-face {
  font-family: Chunkfive;
  src: url("./assets/font/Chunkfive Ex.ttf");
}

@font-face {
  font-family: DINRegularAlternate;
  src: url("./assets/font/DIN/DINRegularAlternate.ttf");
}
@font-face {
  font-family: Poppins;
  src: url("./assets/font/poppins/Poppins-Light.ttf");
}

/* Element UI 移动端适配 */
@media screen and (max-width: 768px) {
  .el-dialog {
    width: 90% !important;
    margin: 5vh auto !important;
    max-height: 90vh;
    border-radius: 12px !important;
  }
  
  .el-dialog__header {
    padding: 16px 20px 12px !important;
  }
  
  .el-dialog__body {
    padding: 16px 20px !important;
    max-height: calc(90vh - 120px);
    overflow-y: auto;
  }
  
  .el-dialog__footer {
    padding: 12px 20px 16px !important;
  }
  
  .el-message-box {
    width: 85% !important;
    max-width: 320px !important;
  }
  
  .el-notification {
    width: calc(100% - 32px) !important;
    left: 16px !important;
    right: 16px !important;
  }
}

/* 移动端菜单打开时禁止页面滚动 */
body.mobile-menu-open {
  overflow: hidden !important;
  position: fixed;
  width: 100%;
  height: 100%;
}

/* ==========================================================================
   Element UI 按钮可读性及对比度优化（欧美门户无障碍标准）
   ========================================================================== */

/* 1. 优化所有类型为 success 的按钮（绿色按钮）及其他次级绿按钮的文字可读性 */
.el-button--success,
.login-btn {
  color: #ffffff !important; /* 使用白字，提供清爽的欧美现代视觉感受 */
  font-weight: 600 !important;
  background-color: #8cc43f !important;
  border-color: #8cc43f !important;
  transition: var(--transition-smooth);
}

.el-button--success:hover,
.el-button--success:focus,
.login-btn:hover,
.login-btn:focus {
  background-color: #7ab32e !important;
  border-color: #7ab32e !important;
  color: #ffffff !important;
}

/* 2. 优化登录/注册页面主提交按钮：改用品牌蓝，具有 5.4:1 超高对比度，清晰美观 */
.submit-btn {
  color: #ffffff !important;
  background-color: #1a5490 !important;
  border-color: #1a5490 !important;
  font-weight: 600 !important;
  transition: var(--transition-smooth);
}

.submit-btn:hover,
.submit-btn:focus {
  background-color: #113e6d !important;
  border-color: #113e6d !important;
  box-shadow: var(--shadow-md);
}

/* 3. 核心优化：验证码发送/倒计时按钮在倒计时状态下的数字显示 */
.el-button.code-getting,
.el-button.codeGeting {
  background-color: #f0fdf4 !important; /* 浅绿底色 */
  border-color: #8cc43f !important;
  color: #16a34a !important;           /* 鲜明绿字，清晰易读 */
  opacity: 1 !important;
  font-weight: 600 !important;
}

/* 当验证码按钮被禁用（包括正在倒计时）时，保持高对比度显示 */
.el-button.is-disabled.code-getting,
.el-button.is-disabled.codeGeting,
.el-button.is-disabled:hover.code-getting,
.el-button.is-disabled:hover.codeGeting {
  background-color: #f0fdf4 !important;
  border-color: #8cc43f !important;
  color: #16a34a !important; /* 绿色倒计时数字，高对比度 */
  opacity: 1 !important;
  font-weight: 600 !important;
}

/* 优化普通被禁用的发送验证码按钮（例如邮箱格式不正确时），提升其文字对比度 */
.el-button.is-disabled,
.el-button.is-disabled:hover,
.el-button.is-disabled:focus {
  color: #94a3b8 !important; /* 使用中灰色代替 Element UI 的超淡灰色 */
  background-color: #f8fafc !important;
  border-color: #e2e8f0 !important;
}

/* 4. 彻底解决 Element UI 朴素主按钮 (type="primary" plain) 样式问题（消除绿底蓝字冲突） */
.el-button--primary.is-plain {
  color: #8cc43f !important;            /* 字体颜色改为品牌绿，防止出现默认的 Element 蓝色 */
  background-color: #ffffff !important; /* 保持白底，防止被 common.scss 的全局 background 强行染绿 */
  border-color: #8cc43f !important;     /* 边框为品牌绿 */
}

/* hover 或 focus 时，填充满绿色背景，文字变白 */
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  background-color: #8cc43f !important;
  border-color: #8cc43f !important;
  color: #ffffff !important;
}

/* 禁用状态下的 plain 按钮（如邮箱格式不对时），保持浅灰质感，确保无障碍对比度 */
.el-button--primary.is-plain.is-disabled,
.el-button--primary.is-plain.is-disabled:hover,
.el-button--primary.is-plain.is-disabled:focus {
  color: #94a3b8 !important;
  background-color: #f8fafc !important;
  border-color: #e2e8f0 !important;
}
</style>
